module.exports = __webpack_public_path__ + "img/ico_apply_active.93ab9436.svg";